import React, { useContext, useState, useEffect } from "react";
import { Modal, Box, Button, Typography, Table, TableBody, TableCell, TableContainer, TableRow, Paper, IconButton, TableHead, } from "@mui/material";
import { ThemeContext } from "../../../context/ThemeContext";
import { updateSLTPOrders, deleteSLTPOrders, modifyPositionSLTP } from "../../../api/request/dashboard/dashboard";
import toast from 'react-hot-toast';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { editSLTPOrder, deleteSLTPOrder, addSLTPOrder } from "../../../store/Slices/orderPositionSlice";
import CloseIcon from "@mui/icons-material/Close";
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import { DeleteOutline, EditOutlined } from '@mui/icons-material'
import AddEditModal from "./AddEditModal";
import { useTranslation } from "react-i18next";
import { addJournalLog } from "../../tab/tabview/journal/addJournalLog";
import { getCookies } from "../../../services/Cookies";

const initForm = { amount: "", st: "", tp: "" }
const EditPositionModal = ({ open, handleClose, editSLTP }) => {
    console.log(editSLTP);
    
    const { darkMode } = useContext(ThemeContext);
    const [selectedSLTP, setSelectedSLTP] = useState(null);
    const [isOpenEdit, setIsOpenEdit] = useState(false);
    const [isEdit, setisEdit] = useState(false);
    const [formData, setFormData] = useState(initForm);
    const dispatch = useDispatch()
    const sltpArray = Array.isArray(editSLTP) ? editSLTP : editSLTP ? [editSLTP] : [];
    const symbol = useSelector(state => state.updateSymbol.symbols?.[editSLTP[0].symbolId])
    const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);
    const { t } = useTranslation()
    const positions = useSelector((state) => state.orderPosition.positions, shallowEqual);
    const selectedPositionId = sltpArray[0]?.positionId;
    const selectedPosition = positions.find(pos => pos.id === selectedPositionId);
    const totalAmount = sltpArray.reduce((sum, item) => sum + item.amount, 0);
    const username = getCookies('username')

    // const maxAmount = parseFloat((selectedPosition?.amount - totalAmount).toFixed(decimalPlaces));
    const maxAmount = isEdit
        ? Number((selectedPosition?.amount ?? 0).toFixed(decimalPlaces))
        : Number(((selectedPosition?.amount ?? 0) - (totalAmount ?? 0)).toFixed(decimalPlaces));


    useEffect(() => {
        setFormData({
            amount: selectedSLTP?.amount || "",
            st: selectedSLTP?.stopLoss || "",
            tp: selectedSLTP?.takeProfit || ""
        });
    }, [selectedSLTP]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "amount" && Number(value) > maxAmount) {
            toast.error(`Amount cannot exceed ${maxAmount}`);
            return;
        }
        if (maxAmount === 0) {
            toast.error("All lots are managed.");
            return;
        }
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleEdit = async () => {
        if (!selectedSLTP) return toast.error("No order selected");

        const updatedOrder = {
            id: selectedSLTP.id,
            amount: formData.amount,
            stopLoss: formData.st === "" ? null : formData.st,
            takeProfit: formData.tp === "" ? null : formData.st,
            accountId: selectedSLTP.accountId
        };

        try {
            const response = await updateSLTPOrders(updatedOrder);
            dispatch(editSLTPOrder(response));
            // toast.success("SLTP updated successfully");
            // setIsOpenEdit(false)
            handleClose();
        } catch (error) {
            toast.error("Failed to update order");
        }
    };

    const handlePlaceOrder = async () => {
        if (!editSLTP) return toast.error("No order selected");

        const selectedOrder = editSLTP[0]
        const newOrder = {
            accountId: selectedOrder.accountId,
            positionId: selectedOrder.positionId,
            amount: Number(formData.amount),
            stopLoss: formData.st,
            takeProfit: formData.tp,
            // ...(formData.stopLoss !== undefined && formData.stopLoss !== "" && !isNaN(Number(formData.stopLoss)) && {
            //     stopLoss: Number(formData.stopLoss),
            // }),
            // ...(formData.takeProfit !== undefined && formData.takeProfit !== "" && !isNaN(Number(formData.takeProfit)) && {
            //     takeProfit: Number(formData.takeProfit),
            // }),
        };


        // const takeProfitTrimmed = formData.takeProfit?.toString().trim();
        // if (takeProfitTrimmed && !isNaN(Number(takeProfitTrimmed))) {
        //     newOrder.takeProfit = Number(takeProfitTrimmed);
        // }

        // const stopLossTrimmed = formData.stopLoss?.toString().trim();
        // if (stopLossTrimmed && !isNaN(Number(stopLossTrimmed))) {
        //     newOrder.stopLoss = Number(stopLossTrimmed);
        // }

        try {
            const response = await modifyPositionSLTP(newOrder);
            dispatch(addSLTPOrder(response));
            // toast.success("New SLTP order placed successfully");
            handleClose()
        } catch (error) {
            console.error("Error placing SLTP order:", error);
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Failed to place SLTP order";
            toast.error(errorMessage);
        }

    };

    const handleDelete = async (sltp) => {
        if (!sltp) return toast.error("No SLTP selected");

        try {
            const data = {
                accountId: sltp.accountId,
                id: sltp.id
            };
            await deleteSLTPOrders(data);
            dispatch(deleteSLTPOrder(sltp.id));
            // toast.success("SLTP deleted successfully");
            handleClose();
        } catch (error) {
            addJournalLog('deleteManageOrderError', `Delete Pending order: #${selectedPosition.id} failure: ${error}, Account ${username}: ${sltp.accountId}.`);
            toast.error("Failed to delete SLTP", error);
        }
    };


    useEffect(() => {
        if (!isOpenEdit) {
            setisEdit(false);
        }
    }, [isOpenEdit])

    const handleAddNewSLTP = () => {
        if (maxAmount === 0) {
            toast.error("All lots are managed.");
            return;
        }
        setIsOpenEdit(true);
        setFormData(initForm);
        setisEdit(false);
    };
    return (
        <>
            <Modal open={open} onClose={handleClose} aria-labelledby="edit-position-modal" maxWidth="sm" closeAfterTransition slots={{ backdrop: Backdrop }} slotProps={{ backdrop: { timeout: 500, }, }}>
                <Fade in={open}>
                    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: darkMode ? "var(--background-color)" : 'var(--white)', }}>
                        <Box className="bg-primary" sx={{ padding: '5px', px: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Typography id="edit-position-modal" variant="body1" sx={{ color: "var(--white)" }} >{t('editPosition')}</Typography>
                            <IconButton onClick={handleClose} sx={{ color: "var(--white)" }}><CloseIcon sx={{ fontSize: 15 }} /></IconButton>
                        </Box>

                        <Box sx={{ padding: 2 }} container>
                            {maxAmount > 0 && (<div className="flex justify-end"><Button onClick={handleAddNewSLTP} variant="outlined" size="small">{t('addNewSLTP')}</Button></div>)}

                            {sltpArray.length > 0 ? (
                                <Box sx={{ maxHeight: 200, overflowY: "auto", mb: 2 }}>
                                    <TableContainer component={Paper} sx={{ mt: 2, mb: 2, border: "1px solid #c6c6c6", borderRadius: 1 }}>
                                        <Table size="small" sx={{ minWidth: 250, borderCollapse: "collapse" }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center">{t('amount')}</TableCell>
                                                    <TableCell align="center">{t('stopLoss')}</TableCell>
                                                    <TableCell align="center">{t('takeProfit')}</TableCell>
                                                    <TableCell align="center">{t('actions')}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {sltpArray.map((sltp, index) => (
                                                    <TableRow key={index} hover sx={{ cursor: "pointer" }}>
                                                        <TableCell align="center" sx={{ fontSize: 13, width: "20%" }}> {Number(sltp.amount).toFixed(decimalPlaces)} </TableCell>
                                                        <TableCell align="center" sx={{ fontSize: 13, width: "20%" }}>
                                                            {sltp.stopLoss != null && sltp.stopLoss !== '' ? Number(sltp.stopLoss).toFixed(symbol.digits) : ''}
                                                        </TableCell>

                                                        <TableCell align="center" sx={{ fontSize: 13, width: "20%" }}>
                                                            {sltp.takeProfit != null && sltp.takeProfit !== '' ? Number(sltp.takeProfit).toFixed(symbol.digits) : ''}
                                                        </TableCell>

                                                        <TableCell align="center" sx={{ fontSize: 13, color: "#da5244", width: "20%", "& .MuiSvgIcon-root": { fontSize: 17, } }} ><DeleteOutline onClick={e => { setSelectedSLTP(sltp); handleDelete(sltp) }} /> <EditOutlined onClick={e => { setSelectedSLTP(sltp); setIsOpenEdit(true); setisEdit(true); }} /> </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            ) : null}
                        </Box>
                    </Box>
                </Fade>
            </Modal>
            {isOpenEdit && <AddEditModal sltpArray={sltpArray} sltp={sltpArray?.[0] || {}} isOpenEdit={isOpenEdit} setIsOpenEdit={setIsOpenEdit} isEdit={isEdit} formData={formData} setFormData={setFormData} handleChange={handleChange} handleEdit={handleEdit} handlePlaceOrder={handlePlaceOrder} />}
        </>
    );

};

export default EditPositionModal;
